import {
    getMerchantBankAccounts,
    addMerchantBankAccounts,
    updateMerchantBankAccounts,
    merchantsDocData,
    fetchMerchantBankAccountsById,
    getMerchantBankAccountCount,
    getMerchantVirtualAccounts
  } from "../../services/MerchantBankAccountsService";
  import {formatSuccess,formatError} from '../../services/commonServices'
  export const MERCHANT_BANK_ACCOUNT_LIST_INITIATED = "MERCHANT_BANK_ACCOUNT_LIST_INITIATED";
  export const MERCHANT_BANK_ACCOUNT_INITIATED = "MERCHANT_BANK_ACCOUNT_INITIATED";
  export const MERCHANT_BANK_ACCOUNT_LIST_LOADED = "MERCHANT_BANK_ACCOUNT_LIST_LOADED";
  export const MERCHANT_VIRTUAL_ACCOUNT_LIST_INITIATED = "MERCHANT_VIRTUAL_ACCOUNT_LIST_INITIATED";
  export const MERCHANT_VIRTUAL_ACCOUNT_INITIATED = "MERCHANT_VIRTUAL_ACCOUNT_INITIATED";
  export const MERCHANT_VIRTUAL_ACCOUNT_LIST_LOADED = "MERCHANT_VIRTUAL_ACCOUNT_LIST_LOADED";
  export const MERCHANT_VIRTUAL_ACCOUNT_FAILED = "MERCHANT_VIRTUAL_ACCOUNT_FAILED";
  export const MERCHANT_BANK_ACCOUNT_LOADED = "MERCHANT_BANK_ACCOUNT_LOADED";
  export const MERCHANT_BANK_ACCOUNT_FAILED = "MERCHANT_BANK_ACCOUNT_FAILED";
  export const MERCHANT_BANK_ACCOUNT_COUNT_INITIATED = "MERCHANT_BANK_ACCOUNT_COUNT_INITIATED";
  export const MERCHANT_BANK_ACCOUNT_COUNT_LOADED = "MERCHANT_BANK_ACCOUNT_COUNT_LOADED";
  export const MERCHANT_BANK_ACCOUNT_COUNT_FAILED  = "MERCHANT_BANK_ACCOUNT_COUNT_FAILED";
  export const MERCHANT_BANK_ACCOUNT_DOC_INITIATED = "MERCHANT_BANK_ACCOUNT_DOC_INITIATED";
  export const MERCHANT_BANK_ACCOUNT_DOC_LOADED = "MERCHANT_BANK_ACCOUNT_DOC_LOADED";
  export const MERCHANT_BANK_ACCOUNT_DOC_FAILED  = "MERCHANT_BANK_ACCOUNT_DOC_FAILED";

  
  export const loadMerchantBankAccount = (getData) => {
    return (dispatch) => {
      dispatch({ type: MERCHANT_BANK_ACCOUNT_LIST_INITIATED });
      getMerchantBankAccounts(getData)
        .then((response) => {
          dispatch({ type: MERCHANT_BANK_ACCOUNT_LIST_LOADED, payload: response.data.data });
        })
        .catch((error) => {
          dispatch({ type: MERCHANT_BANK_ACCOUNT_FAILED, payload: error.message });
        });
    };
  };


  export const loadMerchantVirtualAccount = (getData) => {
    return (dispatch) => {
      dispatch({ type: MERCHANT_VIRTUAL_ACCOUNT_INITIATED });
      getMerchantVirtualAccounts(getData)
        .then((response) => {
          dispatch({ type: MERCHANT_VIRTUAL_ACCOUNT_LIST_LOADED, payload: response.data.data });
        })
        .catch((error) => {
          dispatch({ type: MERCHANT_VIRTUAL_ACCOUNT_FAILED, payload: error.message });
        });
    };
  };


  export const loadMerchantBankAccountCount = (getData) => {
    return (dispatch) => {
      dispatch({ type: MERCHANT_VIRTUAL_ACCOUNT_INITIATED });
      getMerchantBankAccountCount(getData)
        .then((response) => {
          dispatch({ type: MERCHANT_BANK_ACCOUNT_COUNT_LOADED, payload: response.data.data });
        })
        .catch((error) => {
          dispatch({ type: MERCHANT_BANK_ACCOUNT_COUNT_FAILED, payload: error.message });
        });
    };
  };

  

  export const getMerchantBankAccountsById = (id) => {
    return (dispatch) => {
      dispatch({ type: MERCHANT_BANK_ACCOUNT_INITIATED });
      return fetchMerchantBankAccountsById(id)
        .then((response) => {
          dispatch({ type: MERCHANT_BANK_ACCOUNT_LOADED, payload: response.data });
        })
        .catch((error) => {
          dispatch({ type: MERCHANT_BANK_ACCOUNT_FAILED, payload: formatError(error) });
        });
    };
  };

  export const getMerchantBankAccountDocDeatils = (id) => {
    return (dispatch) => {
      dispatch({ type: MERCHANT_BANK_ACCOUNT_DOC_INITIATED });
      return merchantsDocData(id)
        .then((response) => {
          dispatch({ type: MERCHANT_BANK_ACCOUNT_DOC_LOADED, payload: response.data.data });
        })
        .catch((error) => {
          dispatch({ type: MERCHANT_BANK_ACCOUNT_DOC_FAILED, payload: formatError(error) });
        });
    };
  };

  
  export const saveMerchantBankAccountAction = (data, isEdit, id, navigate) => {
    return (dispatch) => {
      dispatch({ type: MERCHANT_BANK_ACCOUNT_INITIATED });
      const apiCall = isEdit ? updateMerchantBankAccounts(id, data) : addMerchantBankAccounts(data);
      return apiCall
        .then((response) => {
          formatSuccess('Merchant Bank Account', response.data)
          if(!isEdit){
            setTimeout(()=>{
              navigate('/merchants-bank-accounts');
            },1000)
          }
          else{
            dispatch({ type: MERCHANT_BANK_ACCOUNT_LOADED, payload: response.data.data });
          }
        })
        .catch((error) => {
          if(error && error.response && error.response.data){
            dispatch({ type: MERCHANT_BANK_ACCOUNT_FAILED, payload: formatError(error.response.data) });
          }
          else{
            dispatch({ type: MERCHANT_BANK_ACCOUNT_FAILED, payload: formatError(error.message) });
          }
        });
    };
  };